import { render, staticRenderFns } from "./ItemsSettings.vue?vue&type=template&id=3d3ddd60&"
import script from "./ItemsSettings.vue?vue&type=script&lang=js&"
export * from "./ItemsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports